import { Grid2 as Grid } from "@mui/material"
import { Label, Subtitle2 } from "../Typography/Typography"

interface MissionTitleProps {
    loading?: boolean
    missionName?: string
}

export const MissionTitle = ({ loading, missionName }: MissionTitleProps) => {
    return (
        <Grid>
            <Subtitle2 disableGutter>Mission Title</Subtitle2>
            <Label data-testid={"mission-title"}>{!loading && missionName}</Label>
        </Grid>
    )
}
